module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="photoInputForm">\n    <div>\n        <label class="photoInputFormLabel photoInputFormLabelPosition" for="file">Ajout de documents</label>\n        <input class="photoInputFormInput specialFileMask formInput" type="text" placeholder="Parcourir..." aria-label="Parcourir..." disabled>\n        <input class="photoInputFormInput photoInputFormFile formInput" type="file" id="file" name="file" multiple>\n    </div>\n    <div class="pendingFilesHolder">\n    </div>\n</div>';

}
return __p
}